import styled from "styled-components";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import instance from "src/API/MainAPI";

const Main = styled.main`
  background-color: #f8f9fa;
  width: 100%;
  padding-left: 160px;
  overflow: hidden;
`;

const DashboardContainer = styled.div`
  width: 95%;
  height: 85vh;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DashboardIframe = styled.iframe`
  width: 95%;
  height: 95%;
  border: none;
  display: block;
  margin: 0 auto;
`;

const LoadingMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85vh;
  font-size: 18px;
  color: #666;
`;

const ErrorMessage = styled(LoadingMessage)`
  color: #ff6b6b;
`;

// API 응답 타입 정의
interface DashboardResponse {
  dashboardUrl: string;
}

// Dashboard URL을 가져오는 API 함수
const fetchDashboardUrl = async (gameId: string): Promise<DashboardResponse> => {
  const response = await instance.get(`/v1/elastic/games/${gameId}/dashboard`);
  return response.data;
};

export default function Dashboard() {
    const [isLoading, setIsLoading] = useState(true);
    const { gameId } = useParams<{ gameId: string }>();
    
    // Dashboard URL을 가져오는 쿼리
    const { data: dashboardData, isError, error } = useQuery<DashboardResponse>({
      queryKey: ['dashboard', gameId],
      queryFn: () => fetchDashboardUrl(gameId!),
      enabled: !!gameId
    });
    
    // iframe이 로드되면 로딩 상태를 false로 변경
    const handleIframeLoad = () => {
        setIsLoading(false);
    };
    
    // if (isError) {
    //   return (
    //     <Main>
    //       <ErrorMessage>
    //         대시보드를 불러오는데 실패했습니다. 다시 시도해주세요.
    //       </ErrorMessage>
    //     </Main>
    //   );
    // }
    
    return (
        <Main>
            <DashboardContainer>
                {/* {isLoading && <LoadingMessage>대시보드를 불러오는 중입니다...</LoadingMessage>} */}
                <DashboardIframe 
                      src={"https://test-report.plithus.com/G7cZCL3reJpen0u2cze-EdwVp65l1rsjMuPb0Es6oWI="}
                      onLoad={handleIframeLoad}
                      title="Kibana Dashboard"
                      allow="fullscreen"
                  />
                {dashboardData && (
                  <DashboardIframe 
                      src={dashboardData.dashboardUrl || "https://test-report.plithus.com/G7cZCL3reJpen0u2cze-EdwVp65l1rsjMuPb0Es6oWI="}
                      onLoad={handleIframeLoad}
                      title="Kibana Dashboard"
                      allow="fullscreen"
                  />
                )}
            </DashboardContainer>
        </Main>
    );
}